import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconFileDevis = _resolveComponent("IconFileDevis")!
  const _component_UilArrowRight = _resolveComponent("UilArrowRight")!
  const _component_UilFileCheck = _resolveComponent("UilFileCheck")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TacheItem = _resolveComponent("TacheItem")!

  return (_ctx.tache.type_tache === 'devis_to_cmd')
    ? (_openBlock(), _createBlock(_component_TacheItem, {
        key: 0,
        tache: _ctx.tache
      }, {
        icons: _withCtx(() => [
          _createVNode(_component_IconFileDevis),
          _createVNode(_component_UilArrowRight),
          _createVNode(_component_UilFileCheck)
        ]),
        libelle: _withCtx(() => [
          (_ctx.tache.devis && _ctx.tache.commande)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("devis.devis")) + " #" + _toDisplayString(_ctx.tache.devis.id_4d), 1),
                _createVNode(_component_UilArrowRight),
                _createVNode(_component_router_link, {
                  to: { name: 'commandes_factures_commandes_item', params: { id: _ctx.tache.commande.id, }, }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("commande.commande")) + " #" + _toDisplayString(_ctx.tache.commande.id_4d), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.tache.type_tache_verbose), 1))
        ]),
        _: 1
      }, 8, ["tache"]))
    : _createCommentVNode("", true)
}